import React, { Component } from "react";
import "./Software.css";
import {AppContext, AppContextType} from "../../AppContext";
import {BulletList} from "../../components/bullet-list/BulletList";
import firebase from "firebase";
import {ScreenshotsGallery} from "../../components/screenshots-gallery/ScreenshotsGallery";
import {NewsGrid} from "../../components/news-grid/NewsGrid";
import {Helmet} from "react-helmet";

type Props = {
};

type State = {
  software:any;
};

class Software extends Component<Props, State> {

  constructor(props: Props) {
    super(props);
  }

  componentDidMount() {
    const ctx = (this.context as AppContextType).appContext;

    const dbRef = firebase.database().ref(ctx.basePath + '/pagine/software');
    dbRef.on('value', snapshot => {
      this.setState({software: snapshot.val()})
    });
  }

  render() {
    return (
     <div id={'software-page'}>

         {/* SEO */}
         <Helmet>
             {this.state?.software?.seo?.meta_titolo?._value ?
                 <title>{this.state?.software?.seo?.meta_titolo?._value + " - " + process.env.REACT_APP_TITLE}</title> :
                 <title>{process.env.REACT_APP_TITLE}</title>}
             <meta name='description' content={this.state?.software?.seo?.meta_descrizione?._value as string}/>
             <meta name='keywords' content={this.state?.software?.seo?.meta_keywords?._value}/>
         </Helmet>

       {/* Header software */}
       <div className={'bullet-lists'}
            data-aos="fade-in"
            data-aos-once="true">
         {this.state?.software?.header_software && this.state?.software?.header_software?._list &&
         Object.keys(this.state?.software?.header_software._list).length > 0 ?
             Object.keys(this.state?.software?.header_software._list)
                 ?.filter(key => this.state?.software?.header_software._list[key]?._id != 0)
                 ?.map(key => this.state?.software?.header_software._list[key])
                 ?.sort((a: any, b: any) => a?._order > b?._order ? 1 : -1)
                 .map((item: any, index: number) => {
                   return <BulletList title={item?.titolo?._value}
                                      description={item?.descrizione?._value}
                                      bulletList={item?.elenco_puntato?._list}
                                      gallery={item?.gallery?._list}></BulletList>
                 })
             : null
         }
       </div>

       {/* Galleries software */}
       <div className={'galleries'}>
         {this.state?.software?.galleries_software && this.state?.software?.galleries_software?._list &&
         Object.keys(this.state?.software?.galleries_software._list).length > 0 ?
             Object.keys(this.state?.software?.galleries_software._list)
                 ?.filter(key => this.state?.software?.galleries_software._list[key]?._id != 0)
                 ?.map(key => this.state?.software?.galleries_software._list[key])
                 ?.sort((a: any, b: any) => a?._order > b?._order ? 1 : -1)
                 .map((item: any, index: number) => {
                   return <ScreenshotsGallery title={item?.titolo_gallery?._value}
                                      description={item?.descrizione_gallery?._value}
                                              headerButton={
                                                {
                                                  etichetta: item?.pulsante?.etichetta?._value,
                                                  link: item?.pulsante?.link?._value
                                                }
                                              }
                                      gallery={item?.gallery_immagini?._list}></ScreenshotsGallery>
                 })
             : null
         }
       </div>


         {/* Liste elenco puntato */}
         <div id={'lists-container-home'}>
             {this.state?.software?.liste_elenco_puntato && this.state?.software?.liste_elenco_puntato?._list &&
             Object.keys(this.state?.software?.liste_elenco_puntato._list).length > 0 ?
                 Object.keys(this.state?.software?.liste_elenco_puntato._list)
                     ?.filter(key => this.state?.software?.liste_elenco_puntato._list[key]?._id != 0)
                     ?.map(key => this.state?.software?.liste_elenco_puntato._list[key])
                     ?.sort((a: any, b: any) => a?._order > b?._order ? 1 : -1)
                     .map((item: any, index: number) => {
                         return <BulletList title={item?.titolo?._value}
                                            description={item?.descrizione?._value}
                                            headerButton={
                                                {
                                                    etichetta: item?.pulsante?.etichetta?._value,
                                                    link: item?.pulsante?.link?._value
                                                }
                                            }
                                            bulletList={item?.elenco_puntato?._list}
                                            gallery={item?.gallery?._list}></BulletList>
                     })
                 : null
             }
         </div>


         {/* News */}
         <NewsGrid title={this.state?.software?.news?.titolo_news?._value}
                      headerButton={{
                          etichetta:this.state?.software?.news?.pulsante?.etichetta?._value,
                          link: this.state?.software?.news?.pulsante?.link?._value
                      }}
                      gallery={this.state?.software?.news?.carosello_news?._list}/>
     </div>
    );
  }


}

Software.contextType = AppContext;
export default Software;
